import { IMultiLanguages } from "../types/common";

export class Network {
  _id?: string;
  name: string;
  rpcUrl: string;
  chainId: string;
  symbol: string;
  imageUrl: string;
  decimal: number;
  file?: any;
  explorer: string;
  description: IMultiLanguages<string>;
  type: ETypeOfNetwork;
  constructor();
  constructor(obj?: Network);
  constructor(obj?: any) {
    this._id = obj?._id || "";
    this.name = obj?.name || "";
    this.rpcUrl = obj?.rpcUrl || "";
    this.chainId = obj?.chainId || "";
    this.symbol = obj?.symbol || "";
    this.imageUrl = obj?.imageUrl || "";
    this.decimal = obj?.decimal || 18;
    this.explorer = obj?.explorer || "";
    this.description = {
      vi: obj?.description?.vi,
      en: obj?.description?.en,
    };
    this.type = obj?.type || "";
  }
}

export class Chain {
  id: number;
  icon: string;
  name: string;
  testnet: boolean;
  nativeCurrency: {
    decimals: number;
    name: string;
    symbol: string;
  };
  rpcUrls: {
    default: {
      http: string[];
    };
    public: {
      http: string[];
    };
  };
  constructor();
  constructor(obj?: Network);
  constructor(obj?: Network) {
    this.id = Number(obj?.chainId);
    this.icon = obj?.imageUrl || "";
    this.name = obj?.name || "";
    this.testnet = obj?.type == ETypeOfNetwork?.TESTNET;
    this.nativeCurrency = {
      decimals: obj?.decimal || 18,
      name: obj?.symbol || "",
      symbol: obj?.symbol || "",
    };
    this.rpcUrls = {
      default: {
        http: [obj?.rpcUrl || ""],
      },
      public: {
        http: [obj?.rpcUrl || ""],
      },
    };
  }
}

export enum ETypeOfNetwork {
  MAINNET = "mainnet",
  TESTNET = "testnet",
}
